import { Panel } from "capitalrx-components-2.0/lib/general";
import { Shelf, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { HTMLAttributes, PropsWithChildren, forwardRef } from "react";

export const PrintableWrapper = forwardRef<HTMLDivElement, PropsWithChildren & HTMLAttributes<HTMLDivElement>>(function PrintableWrapper(props, ref) {
  const { children, className } = props;
  const { width, height, padding } = useResponsive({
    width: {
      mobile: "100%",
      desktop: "100%",
    },
    height: {
      mobile: "",
      desktop: "100%",
    },
    padding: {
      mobile: 0,
      desktop: 48,
    },
  });

  return (
    <div style={{ padding }} className={className}>
      <Shelf alignment="center">
        <Panel style={{ width, height, padding: 0 }}>
          <div ref={ref} style={{ padding: "1.5rem" }}>
            {children}
          </div>
        </Panel>
      </Shelf>
    </div>
  );
});
